import { render, staticRenderFns } from "./BannerAdsCycle.vue?vue&type=template&id=99c43fec&"
import script from "./BannerAdsCycle.vue?vue&type=script&lang=js&"
export * from "./BannerAdsCycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports